/* eslint-disable no-template-curly-in-string */
export default {
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['[Game]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Home Team]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Away Team]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Date]'],
          qSortCriterias: [{
            qSortByNumeric: -1,
          }],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ["=Time(Time,'hh:mm')"],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Stadium]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Home Team Goals]'],
        },
        qNullSuppression: false,
      },
      {
        qDef: {
          qFieldDefs: ['[Away Team Goals]'],
        },
        qNullSuppression: false,
      },
    ],
    qMeasures: [{
      qDef: {
        qDef: "=Only({<Stage={'Final','Quarter-finals','Round of 16','Semi-finals','Third Place play-off'}>} [Home Team])",
      },
    }],
    qInitialDataFetch: [{ qWidth: 9, qHeight: 900 }],
    // qInterColumnSortOrder: [3, 2, 4, 5, 0],
  },
};
